import { render, staticRenderFns } from "./CohortsCrud.vue?vue&type=template&id=5e383f83&scoped=true"
import script from "./CohortsCrud.vue?vue&type=script&lang=js"
export * from "./CohortsCrud.vue?vue&type=script&lang=js"
import style0 from "./CohortsCrud.vue?vue&type=style&index=0&id=5e383f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e383f83",
  null
  
)

export default component.exports